/*********************** Custom JS for Boost AI Search & Discovery  ************************/

/*Theme functions*/
var classes$c = {
  loaded: "free-shipping-bar--loaded",
  success: "free-shipping-bar--success"
};
var selectors$z = {
  progressBar: ".free-shipping-bar__bar",
  message: ".free-shipping-bar__message"
};
function n$2(n,t){return void 0===t&&(t=document),t.querySelector(n)}function t$2(n,t){return void 0===t&&(t=document),[].slice.call(t.querySelectorAll(n))}function c$1(n,t){return Array.isArray(n)?n.forEach(t):t(n)}function r$2(n){return function(t,r,e){return c$1(t,function(t){return t[n+"EventListener"](r,e)})}}function e$2(n,t,c){return r$2("add")(n,t,c),function(){return r$2("remove")(n,t,c)}}function o$2(n){return function(t){var r=arguments;return c$1(t,function(t){var c;return (c=t.classList)[n].apply(c,[].slice.call(r,1))})}}function u$1(n){o$2("add").apply(void 0,[n].concat([].slice.call(arguments,1)));}function i$1(n){o$2("remove").apply(void 0,[n].concat([].slice.call(arguments,1)));}function l(n){o$2("toggle").apply(void 0,[n].concat([].slice.call(arguments,1)));}function a$1(n,t){return n.classList.contains(t)}
function freeShippingBar(node) {
  var _node$dataset = node.dataset,
      threshold = _node$dataset.threshold,
      cartTotal = _node$dataset.cartTotal,
      freeShippingSuccessMessage = _node$dataset.freeShippingSuccessMessage,
      freeShippingPendingMessage = _node$dataset.freeShippingPendingMessage;
  cartTotal = parseInt(cartTotal, 10); // Account for different currencies using the Shopify currency rate

  threshold = Math.round(parseInt(threshold, 10) * (window.Shopify.currency.rate || 1));
  var thresholdInCents = threshold * 100;

  _setProgressMessage();

  _setProgressBar();

  u$1(node, classes$c.loaded);

  function _setProgressMessage() {
    var message = n$2(selectors$z.message, node);

    if (cartTotal >= thresholdInCents) {
      u$1(node, classes$c.success);
      message.innerText = freeShippingSuccessMessage;
    } else {
      var remainder = Math.abs(cartTotal - thresholdInCents);
      message.innerHTML = freeShippingPendingMessage.replace("{{ remaining_amount }}", "<span class=\"fs-body-bold\">".concat(formatMoney(remainder), "</span>"));
    }
  }

  function _setProgressBar() {
    var progressBar = n$2(selectors$z.progressBar, node);
    var progress = cartTotal < thresholdInCents ? cartTotal / threshold : 100;
    progressBar.style.setProperty("--progress-width", "".concat(progress, "%"));
  }
}
function formatMoney$1(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

var formatMoney = (function (val) {
  return formatMoney$1(val, window.theme.moneyFormat || "${{amount}}");
});
/* End theme functions*/

if (window.boostSDAppConfig) {
window.boostSDAppConfig.integration =  Object.assign({
wishlists: 'king'
}, window.boostSDAppConfig.integration || {});
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([(componentRegistry)=>{
    componentRegistry.useComponentPlugin('ProductImage', {
      name: 'Move anchor tag',
      apply: () => ({
        afterRender(element) {
          const link = element.getRootElm()?.closest('a');
          const linkWrapper = link?.parentElement;
          const linkClone = link?.cloneNode();
          const imgWrapper = link?.querySelector('.boost-sd__product-image');

          if(!linkWrapper || !link || !imgWrapper || !linkClone) return;
          
          //move anchor tag inside img wrapper
          linkClone.innerHTML = '';
          imgWrapper.appendChild(linkClone);

          //remove old anchor tag
          linkWrapper.innerHTML='';
          linkWrapper.appendChild(link.childNodes[0]);
          
        },
      }),
    });
      componentRegistry.useModulePlugin('CartAPI', {
        name: 'Custom onSucces add to cart',
        apply(builder) {
          builder.on('methodFulfilled', 'addToCart', async (payload) => {
            fetch('/cart')
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              // get cart content from AJAX
              var myCartDrawer = html.querySelector('.quick-cart__container').innerHTML; 
              var cartCount = html.querySelector('span[data-js-cart-count]').innerHTML; 
              // update the real cart content
              document.querySelector('.quick-cart__container').innerHTML = myCartDrawer;
              document.querySelector('span[data-js-cart-count]').innerHTML = cartCount;
              setTimeout(function(){
                if (document.querySelector('.quick-cart__wrapper')) {
                  freeShippingBar(document.querySelector('.free-shipping-bar'));
                  document.querySelector('.quick-cart__wrapper').classList.add('active');
                }
              }, 600)
              
            })
            .catch(e => {
              console.error(e);
            });
            return payload;
          });
        },
      });
}]); 
if (boostSDAppConfig?.themeSettings) {
  boostSDAppConfig.themeSettings.cart.cartStyle = 'none';
}


const customizeSwatches = {
removeOOSProductSwatches: (componentRegistry) => {
  componentRegistry.useComponentPlugin('ProductSwatch', {
    name: 'Remove OOS swatches #197431',
    enabled: true,
    apply: () => ({
      props: (props) => {
         props.maxItem = 100;
         return props;
      },
      afterRender(element) {
        const swatchOptions = element?.getParams()?.props?.options;
        const productData = 
          componentRegistry.getNearestParentElm(element, 'ProductItemWidget')?.getParams()?.props?.product
          || componentRegistry.getNearestParentElm(element, 'QuickView')?.getParams()?.props?.productData;
        if (swatchOptions?.length && productData) {
          const productVariants = productData.variants || [];         
          swatchOptions.forEach((option) => {
            const optionValue = option.value;
            option.available = checkOptionStatus(productVariants, optionValue);
            if (!option.available) {
              const swatchOption = document.querySelector(`label[for*="${option.id}"]`);
              if (swatchOption && swatchOption.closest('.boost-sd__product-swatch-option')) {
                swatchOption.closest('.boost-sd__product-swatch-option').classList.add('sold-out');
              }
            }
          });
        }
      },
    }),
  });
},
};

function checkOptionStatus(variants, optionValue) {
for (let i = 0; i < variants.length; i++) {
  const variant = variants[i];
  const variantOptions = variant.title?.split(' / ') || [];
  if (variantOptions.some((option) => option.toLowerCase() === optionValue.toLowerCase() && variant.available)) {
    return true;
  }
}
return false;
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customizeSwatches.removeOOSProductSwatches,]);

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat((registry) => {
   registry.useModulePlugin('FilterAPI', {
      name: 'Modify data result filter in collection page',
      apply(builder) {
         builder.on('methodFulfilled', 'get', (data) => {
            const result = data.result;

            // example: only take 5 product first
            const products = data.result.products;
           console.log(data.result)
            console.log('products', products);
          
         });
      },
   });
});

 
/* Boost 210559 */
 const collectionHandle = boostSDAppConfig.generalSettings.collection_handle;

const collectionList = ['final-sale', 'mens-final-sale', 'final-sale-womens', 'womens-outlet', 'mens-outlet']

function addFinalSale(element, isGridView) {
	 // Get product data & product item
   let productData = element.getParams().props.product;

   let isFinalSale = false;
   let productCollections = productData.collections;
   for(var i = 0; i < productCollections.length; i++){
     for(var j = 0; j < collectionList.length; j++){
       if(productCollections[i].handle == collectionList[j]){
         isFinalSale = true;
         break;
       }
     }
   }
  if (productData.percent_sale_min >= 40) {
    isFinalSale = true;
  }
    
   let productId = productData.id;
   if (productData?.split_product) {
      productId = productData.variant_id;
   }
   let productItem = document.querySelector('[data-product-id="' + productId + '"]');
    if(productItem !== null){
      if (isGridView && isFinalSale) { // Check if it is grid view
          if(productItem.querySelector('.boost-sd__product-label-text > span') !== null){
            productItem.querySelector('.boost-sd__product-label-text > span').innerHTML = 'Final Sale'
          }
       } else if (isFinalSale) { // List view
          if(productItem.querySelector('.boost-sd__product-label-text > span') !== null){
            productItem.querySelector('.boost-sd__product-label-text > span').innerHTML = 'Final Sale'
          }
       }
    }
  
}

const customize = {
   customizeProductItem: (componentRegistry) => {
      const updateProductItemGridView = {
         name: 'Add final sale badge grid view',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               addFinalSale(element, true);
            }
         })
      };
      const updateProductItemListView = {
         name: 'Add percent sale baldge list view',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               addFinalSale(element);
            }
         }),
      };

      // Register update product grid & list
      componentRegistry.useComponentPlugin('ProductItem', updateProductItemGridView);
      componentRegistry.useComponentPlugin('ProductItemListViewLayout', updateProductItemListView);
   }
}
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.customizeProductItem]);
/* End 210559 */

/* Jack-fix-scroll-safari */
const isiOS = () => {
	return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};
const isSafari = () => {
	return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
};
window.addEventListener("pageshow", function(evt){
      if(evt.persisted && isiOS() || evt.persisted && isSafari()){
          location.reload();
      }
  }, false);
/* End-Fix */